import "../index.css";
import { useEffect } from "react";
import Footer from "../components/Footer";
//import { useAuth } from "../auth/context";
import { PageNav } from "../components/PageNav";
import ReactMarkdown from "react-markdown";

export default function Gaming() {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const markdownContent = `
  # Gambling Disclaimer

**Last Updated: October 25, 2025**

## Important Notice

**StakeAlerts LLC is NOT a gambling site, sportsbook, or betting platform.** We do not:
- Accept or process bets
- Hold funds for gambling purposes
- Operate as a licensed sportsbook
- Have any affiliation with sportsbooks
- Guarantee any betting outcomes

StakeAlerts is an **information service only**. We provide real-time sports betting odds and alerts to help you stay informed about betting opportunities from various sportsbooks.

---

## Age Restriction

**You must be 18 years or older to use this service** (21+ in states where required by law).

By using StakeAlerts, you confirm that you meet the minimum age requirement in your jurisdiction.

---

## Gambling Involves Risk

### Financial Risk
- **Gambling can result in financial loss.** Never bet money you cannot afford to lose.
- There are no guaranteed wins in sports betting.
- Past performance does not predict future results.

### Addiction Risk
- **Gambling can be addictive.** Some people may develop a gambling problem that can harm their finances, relationships, and mental health.
- Know the warning signs of problem gambling (see below).

---

## This is NOT Betting Advice

**StakeAlerts does not provide betting advice, tips, or recommendations.**

- All odds and information are for informational purposes only
- We do not endorse any betting strategies or picks
- You are solely responsible for your betting decisions
- We are not liable for any losses resulting from your bets

**Make your own informed decisions.** Consider your personal circumstances, risk tolerance, and financial situation before gambling.

---

## Know Your Local Laws

**Sports betting laws vary by state and jurisdiction.**

- Sports betting is legal in some U.S. states but not others
- Even where legal, there may be restrictions on types of bets, locations, or operators
- **You are responsible for understanding and complying with gambling laws in your location**
- Using our information service does not mean sports betting is legal in your area

If you're unsure about the legality of sports betting in your jurisdiction, consult local laws or seek legal advice before placing any bets.

---

## No Guarantee of Accuracy

While we strive for accuracy:
- **Odds can change rapidly** and may be outdated by the time you receive them
- Technical issues may cause delays or errors in data
- We do not guarantee the accuracy or timeliness of any information
- Always verify odds directly with the sportsbook before placing a bet

**You use this information at your own risk.**

---

## Responsible Gambling Guidelines

If you choose to gamble, please do so responsibly:

### Set Limits
- ✓ Set a budget before you start and stick to it
- ✓ Only gamble with money you can afford to lose
- ✓ Set time limits for gambling activities
- ✓ Never chase losses

### Keep Perspective
- ✓ Gambling should be entertainment, not a way to make money
- ✓ Don't gamble when upset, depressed, or under the influence
- ✓ Take regular breaks
- ✓ Balance gambling with other activities

### Stay Informed
- ✓ Understand the odds and house edge
- ✓ Know the rules of the games or bets you're making
- ✓ Keep track of your wins and losses
- ✓ Be honest with yourself about your gambling habits

---

## Warning Signs of Problem Gambling

**Do any of these apply to you?**

- Gambling with money you need for bills or essentials
- Borrowing money or selling possessions to gamble
- Spending more time or money gambling than you intended
- Lying to family or friends about gambling
- Feeling guilty or anxious about gambling
- Gambling to escape problems or relieve stress
- Trying to win back losses ("chasing")
- Neglecting work, school, or family due to gambling
- Having arguments with loved ones about gambling
- Thinking about gambling constantly

**If you answered "yes" to any of these questions, you may have a gambling problem.** Please seek help using the resources below.

---

## Get Help for Problem Gambling

If you or someone you know has a gambling problem, help is available:

### National Resources

**National Council on Problem Gambling**
- 24/7 Helpline: **1-800-522-4700**
- Live chat: [www.ncpgambling.org/chat](https://www.ncpgambling.org/chat)
- Text: Text "HOPENY" to 467369 (NY residents)

**Gamblers Anonymous**
- Website: [www.gamblersanonymous.org](https://www.gamblersanonymous.org)
- Find local meetings and support groups

**National Problem Gambling Helpline**
- Call: **1-800-522-4700**
- Available 24/7, free and confidential

### State-Specific Resources

Many states have their own problem gambling resources:
- Visit your state's gaming commission website
- Search for "[Your State] problem gambling hotline"

### Self-Exclusion Programs

Most states with legal sports betting offer self-exclusion programs that allow you to voluntarily ban yourself from gambling sites and venues. Contact your state gaming commission for details.

### Additional Support

**SAMHSA National Helpline** (Substance Abuse and Mental Health Services Administration)
- Call: **1-800-662-4357**
- Free, confidential, 24/7 treatment referral service

**Crisis Text Line**
- Text "HOME" to **741741**
- Free, 24/7 crisis support

---

## For Friends and Family

If someone you care about has a gambling problem:
- Express your concerns in a non-judgmental way
- Encourage them to seek professional help
- Offer to help them find treatment resources
- Consider attending Gam-Anon (support for family members)
- Take care of your own wellbeing

**Gam-Anon**: [www.gam-anon.org](https://www.gam-anon.org) - Support for family and friends of problem gamblers

---

## Our Commitment

At StakeAlerts, we are committed to promoting responsible gambling awareness. While we provide information about betting opportunities, we:
- Encourage users to gamble responsibly
- Provide easy access to problem gambling resources
- Do not target or market to problem gamblers
- Support responsible gambling initiatives

**Remember: Gambling should be fun, not a financial strategy.**

If you're having a problem, please seek help. If you know someone who's struggling, encourage them to get support.

---

## Contact Us

If you have questions or concerns about this disclaimer or responsible gambling:

**StakeAlerts LLC**  
Email: support@stakealerts.com

---

**By using StakeAlerts, you acknowledge that you have read and understood this Gambling Disclaimer and agree to gamble responsibly, if you choose to gamble at all.**`;

  return (
    <div>
      <PageNav />
      <div className="main_div">
        <div
          className="terms-container"
          style={{
            maxWidth: "800px",
            margin: "0 auto",
            padding: "2rem",
            lineHeight: "1.6",
          }}
        >
          <ReactMarkdown
            components={{
              h1: ({ ...props }) => (
                <h1
                  className="font_family_base"
                  style={{
                    fontSize: "2.5rem",
                    marginBottom: "1rem",
                    borderBottom: "2px solid #737373",
                    paddingBottom: "0.5rem",
                  }}
                  {...props}
                />
              ),
              h2: ({ ...props }) => (
                <h2
                  className="font_family_base header_text"
                  style={{
                    fontSize: "1.8rem",
                    marginTop: "2rem",
                    marginBottom: "1rem",
                    // color: "#00bf62",
                  }}
                  {...props}
                />
              ),
              h3: ({ ...props }) => (
                <h3
                  className="font_family_base detail_text"
                  style={{
                    fontSize: "1.4rem",
                    marginTop: "1.5rem",
                    marginBottom: "0.75rem",
                  }}
                  {...props}
                />
              ),
              p: ({ ...props }) => (
                <p
                  className="font_family_base detail_text"
                  style={{ marginBottom: "1rem" }}
                  {...props}
                />
              ),
              ul: ({ ...props }) => (
                <ul
                  className="font_family_base detail_text"
                  style={{ marginLeft: "2rem", marginBottom: "1rem" }}
                  {...props}
                />
              ),
              li: ({ ...props }) => (
                <li
                  className="font_family_base detail_text"
                  style={{ marginBottom: "0.5rem" }}
                  {...props}
                />
              ),
              strong: ({ ...props }) => (
                <strong
                  className="font_family_base header_text"
                  // style={{ color: "#00bf62" }}
                  {...props}
                />
              ),
              hr: ({ ...props }) => (
                <hr
                  style={{
                    border: "none",
                    borderTop: "1px solid #737373",
                    margin: "2rem 0",
                  }}
                  {...props}
                />
              ),
            }}
          >
            {markdownContent}
          </ReactMarkdown>
        </div>
      </div>
      <Footer />
    </div>
  );
}
